<app-add-equipment *ngIf="userType === 'current'"></app-add-equipment>
<app-find-calibration-data
  *ngIf="userType === 'anonymous'"
></app-find-calibration-data>
